import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Card, CardHeader, Box } from '@mui/material';
// components
import { useChart } from '../../../components/chart';

// ----------------------------------------------------------------------

AppWebsiteVisits.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
  chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default function AppWebsiteVisits({ title, subheader, chartLabels, chartData, ...other }) {
  const chartOptions = useChart({
    plotOptions: {
      bar: {
        columnWidth: '10%',
      },
    },
    labels: chartLabels,
    xaxis: {
      type: 'text',
      labels: {
        style: { fontSize: '14px' },
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return Math.round(value);
        },
        style: {
          fontSize: '11px', // Adjust the font size as needed
        },
      },
    },
  });

  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />

      <Box sx={{ p: 1, pb: 1 }} dir="ltr">
        <ReactApexChart type="bar" series={chartData} options={chartOptions} height={395} />
      </Box>
    </Card>
  );
}
